import { Typography } from '@mui/material';
import { toFixedNumber } from 'util/formatters';

type HeartbeatTotalUptimeProps = {
  uptime: number;
  isLoading: boolean;
};

const HeartbeatTotalUptime: React.FC<HeartbeatTotalUptimeProps> = ({ uptime, isLoading }) => {
  const isFullUptime = uptime === 100;
  const formattedUptime = isFullUptime ? '100' : toFixedNumber(uptime);

  return (
    <div className="uptime-modal-total-chart" style={{ width: 'fit-content' }}>
      <div
        style={{
          width: 170,
          height: 170,
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.32)',
          border: '4px solid #00FF7F',
          boxShadow: '0px 4px 16px 0px #00000052',
        }}
      >
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            fontSize={42}
            lineHeight={'55.54px'}
            style={{ fontVariantNumeric: 'tabular-nums' }}
          >
            {!isLoading ? formattedUptime : '0.00'}%
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default HeartbeatTotalUptime;
